<style lang="sass">
    .cash-steps {
        position: relative;
        margin: 0 auto;
        background:#fff;
        height: 72px;
        box-sizing: border-box;
        padding-top:10px;

        .cash-steps-box{
            display: flex;
            width:100%;
            position: absolute;
            z-index:1;
        }

        .cash-steps-item {
            justify-content: center;
            align-items: center;
            flex:1;
            display: flex;
            flex-direction: column;
            color:#A3ACB3;

            .cash-steps-icon {
                width: 30px;
                height: 30px;
                display: flex;
                border-radius: 50%;
                text-align: center;
                justify-content:center;
                align-items: center;
                box-sizing: border-box;
                background: #f7f7f7;
                color: #c0c0c0;
            }

            .cash-steps-label {
                line-height: 32px;
                font-size: 14px;
                color: #999;
            }

            &.is-current {
                .cash-steps-icon {
                    background-color: #00bfe0;
                    color: #fff;
                    border:0;
                    line-height:30px;
                }

                .cash-steps-label{
                    color: #00bfe0;
                }
            }

            &.is-disable {
                opacity: 0.5;
            }
        }
        
        .cash-steps-line-box {
            position: absolute;
            top: 25px;
            height: 2px;
            font-size: 0;
            line-height: 0;
            width:100%;

            .cash-steps-line{
                border-bottom: 2px solid #d9d9d9;
                position: absolute;
                &.is-current{
                    border-color: #00bfe0;
                }

                &.is-disable {
                    opacity: 0.5;
                }
            }
        }
    }
</style>

<template>
    <div class="cash-steps" :style="{width: width + 'px'}">
        <div class="cash-steps-box">
            <div v-for="(step,$i) in steps" class="cash-steps-item" :class="{'is-current': step.current, 'is-disable': step.disable}">
                <span class="cash-steps-icon"><w-icon :width="16" :height="16" :fill="step.current ? '#fff' : '#c0c0c0'" :type="step.iconName"></w-icon></span>
                <span class="cash-steps-label">{{step.text}}</span>
            </div>
        </div>

        <div class="cash-steps-line-box">
            <span v-for="$i in steps.length" v-if="$i<steps.length" 
                :class="{'is-current': steps[$i].current, 'is-disable': steps[$i].disable}" 
                :style="lineStyle($i)" 
                class="cash-steps-line"></span>
        </div>
        
    </div>
</template>


<script>
    export default {
        name: 'c-steps',
        props: {
            steps: Array,
            width: Number
        },
        
        methods:{
            lineStyle($i){
                var w = this.width/this.steps.length;
                return {
                    width: w - 20 + 'px',
                    left: w * ($i - 1 + 0.5) + 10 + 'px'
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// steps.vue?23b1c707